<div class="sepa-setup-container">
  <h3>{{ 'INTL_SEPA_SETUP_TITLE' | translate }}</h3>
  <p class="subtitle">{{ 'INTL_SEPA_SETUP_SUBTITLE' | translate }}</p>

  <!-- When the first debit will be taken (KAP-1855). Trials defer it to the end
       of the free period; without a trial it is initiated immediately. Hidden
       outside a subscribe flow (e.g. updating a payment method). -->
  <div class="status-card first-payment-info" *ngIf="showFirstPaymentInfo">
    <mat-icon>event</mat-icon>
    <span *ngIf="hasTrial">
      {{ 'INTL_SEPA_FIRST_PAYMENT_TRIAL' | translate : { date: (firstPaymentDate | date : 'longDate') } }}
    </span>
    <span *ngIf="!hasTrial">{{ 'INTL_SEPA_FIRST_PAYMENT_TODAY' | translate }}</span>
  </div>

  <div class="status-card" *ngIf="loading">
    <mat-spinner diameter="20"></mat-spinner>
    <span>{{ 'INTL_SEPA_SETUP_PREPARING' | translate }}</span>
  </div>

  <div class="status-card error" *ngIf="!loading && errorMessage">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div class="iban-wrapper" [class.disabled]="loading || submitting || processing">
    <label>{{ 'INTL_SEPA_IBAN' | translate }}</label>
    <div #ibanElementMount class="iban-element"></div>
  </div>

  <!-- Shown only for non-EEA IBANs (UK, CH, MC, SM, AD, VA), which Stripe
       rejects without a full billing address. -->
  <div class="billing-address" *ngIf="requiresBillingAddress" [formGroup]="addressForm">
    <p class="address-hint">{{ 'INTL_SEPA_ADDRESS_REQUIRED_HINT' | translate }}</p>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'INTL_SEPA_ADDRESS_LINE1' | translate }}</mat-label>
      <input matInput formControlName="line1" autocomplete="address-line1" />
      <mat-error *ngIf="addressForm.get('line1')?.hasError('required')">
        {{ 'INTL_SEPA_ADDRESS_LINE1_REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="addressForm.get('line1')?.hasError('minlength')">
        {{ 'INTL_FORM_ERROR_MIN_LENGTH' | translate: addressForm.get('line1')?.getError('minlength') }}
      </mat-error>
      <mat-error *ngIf="addressForm.get('line1')?.hasError('maxlength')">
        {{ 'INTL_FORM_ERROR_MAX_LENGTH' | translate: addressForm.get('line1')?.getError('maxlength') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ 'INTL_SEPA_ADDRESS_LINE2' | translate }}</mat-label>
      <input matInput formControlName="line2" autocomplete="address-line2" />
      <mat-error *ngIf="addressForm.get('line2')?.hasError('maxlength')">
        {{ 'INTL_FORM_ERROR_MAX_LENGTH' | translate: addressForm.get('line2')?.getError('maxlength') }}
      </mat-error>
    </mat-form-field>

    <div class="address-row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'INTL_SEPA_ADDRESS_POSTAL_CODE' | translate }}</mat-label>
        <input matInput formControlName="postalCode" autocomplete="postal-code" />
        <mat-error *ngIf="addressForm.get('postalCode')?.hasError('required')">
          {{ 'INTL_SEPA_ADDRESS_POSTAL_CODE_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="addressForm.get('postalCode')?.hasError('maxlength')">
          {{ 'INTL_FORM_ERROR_MAX_LENGTH' | translate: addressForm.get('postalCode')?.getError('maxlength') }}
        </mat-error>
        <mat-error *ngIf="addressForm.get('postalCode')?.hasError('postalCodeFormat')">
          {{ 'INTL_SEPA_ADDRESS_POSTAL_CODE_INVALID_FORMAT' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'INTL_SEPA_ADDRESS_CITY' | translate }}</mat-label>
        <input matInput formControlName="city" autocomplete="address-level2" />
        <mat-error *ngIf="addressForm.get('city')?.hasError('required')">
          {{ 'INTL_SEPA_ADDRESS_CITY_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="addressForm.get('city')?.hasError('minlength')">
          {{ 'INTL_FORM_ERROR_MIN_LENGTH' | translate: addressForm.get('city')?.getError('minlength') }}
        </mat-error>
        <mat-error *ngIf="addressForm.get('city')?.hasError('maxlength')">
          {{ 'INTL_FORM_ERROR_MAX_LENGTH' | translate: addressForm.get('city')?.getError('maxlength') }}
        </mat-error>
        <mat-error *ngIf="addressForm.get('city')?.hasError('pattern')">
          {{ 'INTL_SEPA_ADDRESS_CITY_INVALID_CHARACTERS' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <p class="address-country" *ngIf="ibanCountry">
      {{ 'INTL_SEPA_ADDRESS_COUNTRY_FROM_IBAN' | translate }} <strong>{{ ibanCountry }}</strong>
    </p>
  </div>

  <div class="actions">
    <button mat-stroked-button (click)="onCancel()" [disabled]="submitting || processing">
      {{ 'INTL_BACK' | translate }}
    </button>
    <button mat-stroked-button color="warn" (click)="onRetry()" [disabled]="loading || submitting || processing">
      {{ 'INTL_SEPA_RETRY_SETUP' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!canSubmit">
      <mat-spinner *ngIf="submitting || processing" diameter="16" class="button-spinner"></mat-spinner>
      <span *ngIf="!(submitting || processing)">{{ 'INTL_SEPA_CONFIRM_PAYMENT_METHOD' | translate }}</span>
    </button>
  </div>
</div>
